import { useEffect } from "react";
import ServicesList from "../utility/ServicesList";
import EditableService from "./EditableService";
import { useDispatch } from "../../store/DataProvider";
import { logoutAdmin } from "../../store/actions";

const Admin = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        logoutAdmin(dispatch);
    }, [dispatch]);

    return (
        <div className="columns-container admin-services">
            <div
                key="first-column"
                className="first-column"
                style={{ marginBottom: 0 }}
            >
                <ServicesList isAdmin={true} />
            </div>
            <div
                key="second-column"
                className="second-column"
                style={{ marginBottom: 0, backgroundColor: "white" }}
            >
                <EditableService />
            </div>
        </div>
    );
};

export default Admin;
